// 兑换码配置文件

// 钻石包配置接口
export interface DiamondPackageConfig {
  id: string;
  diamonds: number;
  price: string;
  link: string;
  gumroadProductId?: string; // Gumroad产品ID，用于API验证
}

// 钻石包配置 - 可配置化
export const DIAMOND_PACKAGES: DiamondPackageConfig[] = [
  {
    id: 'diamond-400',
    diamonds: 400,
    price: '$9.99',
    link: 'https://zackzhong.gumroad.com/l/tfmlpib', // 可配置的购买链接
    gumroadProductId: 'diamond-400' // 对应Gumroad的产品ID
  },
  {
    id: 'diamond-1000', 
    diamonds: 1000,
    price: '$19.99',
    link: 'https://zackzhong.gumroad.com/l/tfmlpib', // 可配置的购买链接
    gumroadProductId: 'diamond-1000' // 对应Gumroad的产品ID
  }
];